import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `QuickbooksIntegration` is an implementation of `AbstractIntegration`
 * for integration with Quickbooks.
 */
export default class QuickbooksIntegration extends AbstractIntegration {
	constructor({ importAttachments = true } = {}) {
		super(...arguments);

		this._importAttachments = importAttachments;
	}

	getName() {
		return "Quickbooks";
	}

	routeName() {
		return "quickbooks";
	}

	isQuickbooksIntegration() {
		return true;
	}

	canBeDisconnected() {
		return true;
	}

	canHaveLinkedDocuments() {
		return true;
	}

	hasInvoiceSupport() {
		return true;
	}

	shouldImportAttachments() {
		return this._importAttachments;
	}

	static getType() {
		return "QuickbooksIntegration";
	}
}
